module.exports = __webpack_public_path__ + "static/media/Miami soffa tyg siri grön 06 detalj 2023 1.75816539.jpg";